export default "__VITE_ASSET__Bc6l$I5g__"